import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SessionItemResultList;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import partial from 'lodash/partial';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import { IconArrowOpenEndLine } from '@instructure/ui-icons';
import { ResultStimulus, generateDisplayPositions } from '@instructure/quiz-core';
import { Flex, GRADE_BY_QUESTION_NEXT, withStyleOverrides } from '@instructure/quiz-common';
import SessionItemResultWrapper from '../SessionItemResultWrapper';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/es/format-message';
export var SessionItemResultList = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_SessionItemResultList = /*#__PURE__*/function (_Component) {
  function SessionItemResultList() {
    var _this;
    _classCallCheck(this, SessionItemResultList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SessionItemResultList, [].concat(args));
    _defineProperty(_this, "nextStudent", function () {
      _this.props.postToParent({
        subject: GRADE_BY_QUESTION_NEXT
      });
    });
    _defineProperty(_this, "renderSessionItemResultWrapper", function (sessionItem, shouldRenderTopBorder) {
      var _this$props = _this.props,
        handleChangePoints = _this$props.handleChangePoints,
        handleChangeFeedback = _this$props.handleChangeFeedback,
        handleChangeGradeStatus = _this$props.handleChangeGradeStatus,
        quizSessionId = _this$props.quizSessionId,
        regradingIdentifier = _this$props.regradingIdentifier,
        renderUpdateButton = _this$props.renderUpdateButton;
      var result = sessionItem.sessionItemResult;
      var item = sessionItem.getItem();
      return jsx(SessionItemResultWrapper, {
        handleChangeFeedback: handleChangeFeedback,
        handleChangeGradeStatus: partial(handleChangeGradeStatus, result.id, item.id),
        handleChangePoints: partial(handleChangePoints, result.id, item.id),
        item: item,
        key: sessionItem.id,
        quizSessionId: quizSessionId,
        isRegrading: sessionItem.id === regradingIdentifier,
        regradingKey: sessionItem.id,
        renderUpdateButton: renderUpdateButton,
        sessionItem: sessionItem,
        shouldRenderTopBorder: shouldRenderTopBorder
      });
    });
    return _this;
  }
  _inherits(SessionItemResultList, _Component);
  return _createClass(SessionItemResultList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToActiveItem();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.quizSessionId !== this.props.quizSessionId) {
        this.scrollToActiveItem();
      }
    }
  }, {
    key: "scrollToActiveItem",
    value: function scrollToActiveItem() {
      var _this$props2 = this.props,
        activeItemId = _this$props2.activeItemId,
        gradeByQuestionEnabled = _this$props2.gradeByQuestionEnabled,
        sessionItems = _this$props2.sessionItems;
      if (gradeByQuestionEnabled && activeItemId) {
        var sessionItem = sessionItems.find(function (si) {
          return si.itemRecord.id === activeItemId;
        });
        if (sessionItem) {
          this.props.scrollToItem(sessionItem.id);
        } else {
          var continueText = jsx(Flex, {
            alignItems: "center"
          }, jsx(View, {
            margin: "0 x-small 0 0"
          }, t('Next Student')), jsx(IconArrowOpenEndLine, null));
          this.props.withConfirm(this.nextStudent, {
            continueText: continueText,
            text: t('The active student does not have this question. Please use the Next Student button to proceed.'),
            title: t('Question Not Available')
          });
        }
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(sessionItem) {
      if (sessionItem.stimulus) {
        return jsx(ResultStimulus, {
          key: sessionItem.id,
          stimulus: sessionItem.stimulusRecord,
          renderItem: this.renderSessionItemResultWrapper,
          sessionItem: sessionItem
          // This prop is necessary to rerender the child items when we enter regrading mode
          ,
          regradingIdentifier: this.props.regradingIdentifier
        });
      }
      return this.renderSessionItemResultWrapper(sessionItem, true);
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;
      return generateDisplayPositions(this.props.sessionItems).map(function (si) {
        return _this2.renderItem(si.record);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.root
      }, this.renderItems());
    }
  }]);
}(Component), _defineProperty(_SessionItemResultList, "displayName", 'SessionItemResultList'), _defineProperty(_SessionItemResultList, "componentId", "Quizzes".concat(_SessionItemResultList.displayName)), _defineProperty(_SessionItemResultList, "propTypes", {
  activeItemId: PropTypes.string,
  gradeByQuestionEnabled: PropTypes.bool,
  handleChangePoints: PropTypes.func.isRequired,
  handleChangeFeedback: PropTypes.func.isRequired,
  handleChangeGradeStatus: PropTypes.func.isRequired,
  postToParent: PropTypes.func.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  regradingIdentifier: PropTypes.string.isRequired,
  renderUpdateButton: PropTypes.func.isRequired,
  scrollToItem: PropTypes.func.isRequired,
  sessionItems: ImmutablePropTypes.list.isRequired,
  withConfirm: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_SessionItemResultList, "defaultProps", {
  activeItemId: null,
  gradeByQuestionEnabled: false
}), _SessionItemResultList)) || _class);
export default SessionItemResultList;